import { Box, Container, CssBaseline, Toolbar, Grid } from "@mui/material";
import { Sidebar } from "../../../../components/";

import DeleteAllDisruption from "./DeleteAllDisruption";
import CreateTrainDisruption from "./CreateTrainDisruption";
import TrainDisruptionList from "./TrainDisruptionList";
import BroadcastStatus from "./BroadcastStatus";
import DisruptionErrorPrompt from "./DisruptionErrorPrompt";
import DisruptionSuccessPrompt from "./DisruptionSuccessPrompt";
import { TypographyXLarge } from "../../../../components/customComponent";
import { useSelector } from "react-redux";
import PreviewDisruption from "./preview/PreviewDisruption";
import { useTranslation } from "react-i18next";
import VerticalPreview from "./preview/VerticalPreview";

const TrainDisruption = () => {
  const { features } = useSelector((state) => state.auth);
  const { loadingDisruption: loading } = useSelector(
    (state) => state.smrtDisruption,
  );

  const { t } = useTranslation("smrtDisruption");

  return (
    <Box sx={{ display: "flex" }}>
      <Sidebar />

      <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
        <Toolbar />
        <CssBaseline />

        <Container maxWidth="xl">
          <Box sx={{ mb: 2 }}>
            <TypographyXLarge sx={{ fontWeight: 700 }}>
              {t("title")}
            </TypographyXLarge>
          </Box>

          <DisruptionErrorPrompt />
          <DisruptionSuccessPrompt />

          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item xs={12}>
              <BroadcastStatus />
            </Grid>

            {!loading && (
              <>
                <Grid item xs={12} lg={2}>
                  <DeleteAllDisruption />
                </Grid>

                <Grid item xs={12} lg={6}></Grid>
                <Grid item xs={12} lg={2}>
                  {features?.["SMRT_SRG"] ? (
                    <VerticalPreview
                      fullWidth={true}
                      previewType={"ALL"}
                      disabled={false}
                    />
                  ) : (
                    <PreviewDisruption
                      fullWidth={true}
                      previewType={"ALL"}
                      disabled={false}
                    />
                  )}
                </Grid>
                <Grid item xs={12} lg={2}>
                  <CreateTrainDisruption />
                </Grid>
              </>
            )}
            <Grid item xs={12}>
              <TrainDisruptionList />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default TrainDisruption;
